// frontend/src/service/galleryService.ts
import axiosInstance from "../configuration/api";

export const getAllSeries = async () => {
  try {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const response = await axiosInstance.get(`${baseUrl}/api/v1/series`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to fetch series");
  }
};

export const getSeriesById = async (id: string) => {
  try {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const response = await axiosInstance.get(`${baseUrl}/api/v1/series/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Series not found");
  }
};

export const getProductById = async (id: string) => {
  try {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const response = await axiosInstance.get(`${baseUrl}/api/v1/product/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Product not found");
  }
};

// export const getProductsBySeries = async (
//   seriesId: string,
//   pageNumber: number = 1,
//   pageSize: number = 12,
//   filters: any = {},
//   sortOptions: any = {}
// ) => {
//   try {
//     const baseUrl = process.env.REACT_APP_API_HOST;
//     const response = await axiosInstance.get(`${baseUrl}/api/v1/product`, {
//       params: {
//         seriesId,
//         pageNumber,
//         pageSize,
//         ...filters,
//         ...sortOptions,
//       },
//     });
//     return response.data;
//   } catch (error: any) {
//     throw new Error(
//       error.response?.data?.message || "Failed to fetch products"
//     );
//   }
// };
export interface SeriesFilterParams {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
  minPrice?: number;
  maxPrice?: number;
  color?: string | string[];
}

export interface SeriesFilterOptions {
  colors: Array<{ value: string; label: string; count: number }>;
  priceRange: {
    minPrice: number;
    maxPrice: number;
  };
}

export interface SeriesProductsResponse {
  success: boolean;
  data: any[];
  pagination: {
    total: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
  filters: {
    applied: any;
    available: SeriesFilterOptions;
    seriesData: any;
  };
}

export const getProductsBySeries = async (
  seriesId: string,
  params?: SeriesFilterParams
): Promise<SeriesProductsResponse> => {
  try {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const response = await axiosInstance.get(`${baseUrl}/api/v1/product`, {
      params: {
        seriesId,
        ...params,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching series products:", error);
    throw new Error(
      error.response?.data?.message || "Failed to fetch series products"
    );
  }
};
